var _excluded = ["table", "keyColumn", "labelColumn", "iconColumn", "settings", "onChange", "onSelectionChange"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { usePickerItemScale } from '@deephaven/components';
import { createKeyedItemKey, TableUtils } from '@deephaven/jsapi-utils';
import { useApi } from '@deephaven/jsapi-bootstrap';
import Log from '@deephaven/log';
import { usePromiseFactory } from '@deephaven/react-hooks';
import useFormatter from "../../useFormatter.js";
import useTableUtils from "../../useTableUtils.js";
import { getItemKeyColumn, getItemLabelColumn } from "./itemUtils.js";
import { useItemRowDeserializer } from "./useItemRowDeserializer.js";
import useSearchableViewportData from "../../useSearchableViewportData.js";
import useWidgetClose from "../../useWidgetClose.js";
var log = Log.module('jsapi-components.useMultiPickerProps');

/** Props that are derived by `useMultiPickerProps`. */

/**
 * Props that are passed through untouched. (should exclude all of the
 * destructured props passed into `useMultiPickerProps` that are not in the
 * spread ...props)
 */

/** Props returned by `useMultiPickerProps` hook. */

export function useMultiPickerProps(_ref) {
  var _props$selectedKeys;
  var tableSource = _ref.table,
    keyColumnName = _ref.keyColumn,
    labelColumnName = _ref.labelColumn,
    iconColumnName = _ref.iconColumn,
    settings = _ref.settings,
    onChange = _ref.onChange,
    onSelectionChange = _ref.onSelectionChange,
    props = _objectWithoutProperties(_ref, _excluded);
  var _usePickerItemScale = usePickerItemScale(),
    itemHeight = _usePickerItemScale.itemHeight;
  var _useFormatter = useFormatter(settings),
    formatValue = _useFormatter.getFormattedString,
    timeZone = _useFormatter.timeZone;

  // Copy table so we can apply filters without affecting the original table.
  var _usePromiseFactory = usePromiseFactory(TableUtils.copyTableAndApplyFilters, [tableSource]),
    tableCopy = _usePromiseFactory.data;
  useWidgetClose(tableCopy);
  var keyColumn = useMemo(() => tableCopy == null ? null : getItemKeyColumn(tableCopy, keyColumnName), [keyColumnName, tableCopy]);
  var labelColumn = useMemo(() => tableCopy == null || keyColumn == null ? null : getItemLabelColumn(tableCopy, keyColumn, labelColumnName), [keyColumn, labelColumnName, tableCopy]);
  var searchColumnNames = useMemo(() => labelColumn == null ? [] : [labelColumn.name], [labelColumn]);
  var deserializeRow = useItemRowDeserializer({
    table: tableCopy,
    iconColumnName,
    keyColumnName,
    labelColumnName,
    formatValue
  });
  var _useSearchableViewpor = useSearchableViewportData({
      reuseItemsOnTableResize: true,
      table: tableCopy,
      itemHeight,
      deserializeRow,
      searchColumnNames,
      timeZone
    }),
    onScroll = _useSearchableViewpor.onScroll,
    onSearchTextChange = _useSearchableViewpor.onSearchTextChange,
    viewportData = _useSearchableViewpor.viewportData;
  var dh = useApi();
  var tableUtils = useTableUtils();

  // Only request columns needed by `deserializeRow` (key, label, and optionally icon).
  var snapshotColumns = useMemo(() => {
    if (tableCopy == null || keyColumn == null) {
      return [];
    }
    var cols = [keyColumn];
    if (labelColumn != null && labelColumn !== keyColumn) {
      cols.push(labelColumn);
    }
    if (iconColumnName != null) {
      try {
        var iconCol = tableCopy.findColumn(iconColumnName);
        cols.push(iconCol);
      } catch (_unused) {
        // icon column not found, skip
      }
    }
    return cols;
  }, [tableCopy, keyColumn, labelColumn, iconColumnName]);

  // When selected keys point to rows outside the initial viewport, we take a table snapshot of
  // just those rows to load their real label data. This avoids moving the viewport and ensures all
  // selected items display correct labels.
  var selectedKeysForSnapshot = (_props$selectedKeys = props.selectedKeys) !== null && _props$selectedKeys !== void 0 ? _props$selectedKeys : props.defaultSelectedKeys;
  var snapshottedKeysRef = useRef(new Set());
  var _useState = useState(new Map()),
    _useState2 = _slicedToArray(_useState, 2),
    snapshotItemsByIndex = _useState2[0],
    setSnapshotItemsByIndex = _useState2[1];

  // Reset when table changes so we re-snapshot.
  useEffect(() => {
    snapshottedKeysRef.current = new Set();
    setSnapshotItemsByIndex(new Map());
  }, [tableCopy]);
  useEffect(function snapshotSelectedKeyLabels() {
    if (tableCopy == null || keyColumn == null || selectedKeysForSnapshot == null || selectedKeysForSnapshot === 'all') {
      return;
    }

    // Determine which keys still need snapshotting.
    var keysToSnapshot = [...selectedKeysForSnapshot].filter(key => !snapshottedKeysRef.current.has(String(key)));
    if (keysToSnapshot.length === 0) {
      return;
    }
    var isCanceled = false;
    var column = tableCopy.findColumn(keyColumn.name);
    var columnValueType = tableUtils.getValueType(column.type);
    _asyncToGenerator(function* () {
      try {
        // Seek row indices for all selected keys
        var rowIndices = [];
        yield Promise.all(keysToSnapshot.map(/*#__PURE__*/function () {
          var _ref3 = _asyncToGenerator(function* (key) {
            if (isCanceled) {
              return;
            }
            var index = yield tableCopy.seekRow(0, column, columnValueType, key);
            if (index !== -1) {
              rowIndices.push(index);
            }
          });
          return function (_x) {
            return _ref3.apply(this, arguments);
          };
        }()));
        rowIndices.sort((a, b) => a - b);
        if (isCanceled || rowIndices.length === 0) {
          return;
        }

        // Take a snapshot of just those rows
        var rangeSet = dh.RangeSet.ofItems(rowIndices);
        var tableData = yield tableCopy.createSnapshot({
          rows: rangeSet,
          columns: snapshotColumns
        });
        if (isCanceled) {
          return;
        }
        var itemMap = new Map();
        tableData.rows.forEach((row, i) => {
          var rowIndex = rowIndices[i];
          var item = deserializeRow(row);
          itemMap.set(rowIndex, {
            key: createKeyedItemKey(rowIndex),
            item
          });
        });
        if (!isCanceled) {
          // Mark keys as successfully snapshotted so they are not re-fetched.
          keysToSnapshot.forEach(key => snapshottedKeysRef.current.add(String(key)));
          setSnapshotItemsByIndex(prev => {
            var merged = new Map(prev);
            itemMap.forEach((value, key) => merged.set(key, value));
            return merged;
          });
        }
      } catch (err) {
        log.error('Error loading labels for selected keys', err);
      }
    })();
    return () => {
      isCanceled = true;
    };
  }, [selectedKeysForSnapshot, tableCopy, keyColumn, tableUtils, dh, deserializeRow, snapshotColumns]);

  // Label cache for every selected item resolved (from viewport or snapshot). This ensures that
  // when search filtering narrows the table, tags for selected items that are no longer in the
  // filtered results still display their correct labels.
  // NOTE: This is passed using a separate `selectedItemLabels` prop so it only affects tag
  // rendering.
  var labelCacheRef = useRef(new Map());
  var _useState3 = useState(new Map()),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedItemLabels = _useState4[0],
    setSelectedItemLabels = _useState4[1];

  // Merge snapshot data into viewport items (needed for initial load of labels, otherwise they
  // display key values).
  var normalizedItems = useMemo(() => {
    if (snapshotItemsByIndex.size === 0) {
      return viewportData.items;
    }
    return viewportData.items.map((item, index) => {
      if (item.item == null) {
        var snapshotItem = snapshotItemsByIndex.get(index);
        if (snapshotItem != null) {
          return snapshotItem;
        }
      }
      return item;
    });
  }, [viewportData.items, snapshotItemsByIndex]);

  // Update the label cache whenever normalizedItems or selected keys change.
  useEffect(function updateLabelCache() {
    var _props$selectedKeys2;
    var currentSelectedKeys = (_props$selectedKeys2 = props.selectedKeys) !== null && _props$selectedKeys2 !== void 0 ? _props$selectedKeys2 : props.defaultSelectedKeys;
    var selectedKeySet;
    if (currentSelectedKeys instanceof Array) {
      selectedKeySet = new Set(currentSelectedKeys.map(String));
    } else if (currentSelectedKeys === 'all') {
      selectedKeySet = null;
    } else {
      selectedKeySet = new Set();
    }
    var cacheUpdated = false;

    // Cache labels from all resolved items that are currently selected. The normalizedItems
    // merge already includes snapshot data, so this single pass should cover both viewport
    // and snapshot sources.
    normalizedItems.forEach(item => {
      if (item.item != null) {
        var key = String(item.item.key);
        var label = item.item.textValue;
        if (label != null && (selectedKeySet == null || selectedKeySet.has(key)) && labelCacheRef.current.get(key) !== label) {
          labelCacheRef.current.set(key, label);
          cacheUpdated = true;
        }
      }
    });
    if (cacheUpdated) {
      setSelectedItemLabels(new Map(labelCacheRef.current));
    }
  }, [normalizedItems, props.selectedKeys, props.defaultSelectedKeys]);
  var onSelectionChangeInternal = useCallback(keys => {
    var _ref4;
    (_ref4 = onChange !== null && onChange !== void 0 ? onChange : onSelectionChange) === null || _ref4 === void 0 || _ref4(keys);
  }, [onChange, onSelectionChange]);
  return _objectSpread(_objectSpread({}, props), {}, {
    normalizedItems,
    selectedItemLabels,
    showItemIcons: iconColumnName != null,
    onChange: onSelectionChangeInternal,
    onScroll,
    onSearchTextChange
  });
}
export default useMultiPickerProps;
//# sourceMappingURL=useMultiPickerProps.js.map